// ============================================================================
// DETACHED CLOCK HAND (Physics-based clock hand that flies off)
// ============================================================================

import CONFIG from '../config.js';

export class DetachedClockHand {
    constructor(x, y, isHourHand) {
        this.x = x;
        this.y = y;
        this.length = isHourHand ? 16 : 20;  // Doubled from 8 and 10
        this.width = 2;  // Doubled from 1
        this.isHourHand = isHourHand;
        this.isPickable = false;  // Clock hands are NOT pickable
        this.isCarried = false;

        // Random velocity based on break force
        const variance = 0.5 + Math.random() * 0.5;
        const baseSpeed = 200 * variance;

        // Random direction
        const angle = Math.random() * Math.PI * 2;

        this.vx = Math.cos(angle) * baseSpeed;
        this.vy = Math.sin(angle) * baseSpeed;

        // Random rotation
        this.rotation = Math.random() * Math.PI * 2;
        this.rotationSpeed = (Math.random() - 0.5) * 10;
    }

    update(dt, tilemap) {
        // No gravity in top-down view

        // Apply environmental friction
        this.vx *= CONFIG.environmentFriction;
        this.vy *= CONFIG.environmentFriction;
        this.rotationSpeed *= CONFIG.environmentFriction;

        // Update position
        const newX = this.x + this.vx * dt;
        const newY = this.y + this.vy * dt;

        // Check wall collisions (bounce with energy loss)
        const tile = tilemap.getTileAt(newX, newY);
        if (!tile || !tilemap.tileTypes[tile.type].walkable) {
            // Hit a wall - bounce back
            // Check which axis caused the collision
            const tileX = tilemap.getTileAt(newX, this.y);
            const tileY = tilemap.getTileAt(this.x, newY);

            if (!tileX || !tilemap.tileTypes[tileX.type].walkable) {
                // Hit horizontal wall
                this.vx = -this.vx * CONFIG.wallBounceEnergyLoss;
            }
            if (!tileY || !tilemap.tileTypes[tileY.type].walkable) {
                // Hit vertical wall
                this.vy = -this.vy * CONFIG.wallBounceEnergyLoss;
            }
        } else {
            this.x = newX;
            this.y = newY;
        }

        // Update rotation
        this.rotation += this.rotationSpeed * dt;
    }

    draw(ctx, camera) {
        ctx.save();
        ctx.translate(this.x, this.y);
        ctx.rotate(this.rotation);

        // Draw clock hand as a line
        ctx.strokeStyle = '#000';
        ctx.lineWidth = this.width;
        ctx.beginPath();
        ctx.moveTo(0, 0);
        ctx.lineTo(0, -this.length);
        ctx.stroke();

        // Draw small circle at base
        ctx.fillStyle = '#000';
        ctx.beginPath();
        ctx.arc(0, 0, 2, 0, Math.PI * 2);  // Doubled from 1
        ctx.fill();

        ctx.restore();
    }
}
